import { useEffect, useState, useContext } from "react";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { UserContext } from "../contexts/UserContext";
import { RequestHelper } from "../../utils/requestHelper";
import _ from "lodash";
import {
  _ACTIONS,
  _EN_COURS_SIGNATURE,
  _SIGNE,
} from "../../utils/_constants";
import CreationOffreAchat from "../forms/mandats/CreationOffreAchat";

const TransmissionOffreAchat = () => {
  const { user } = useContext(UserContext);
  const [users, setUsers] = useState([]);
  const [currentMandat, setCurrentMandat] = useState([]);
  const [refreshMandat, setRefreshMandat] = useState(0);
  const requestHelper = new RequestHelper();
  const currentIdUrl = useParams();
  const {
    register,
    formState: { errors },
  } = useForm({ mode: "onChange	" });

  const disabledSign =
    currentMandat?.statut?.nom === _SIGNE ||
    currentMandat?.statut?.nom === _EN_COURS_SIGNATURE;

  useEffect(() => {
    getUsers();
    /* GET Mandat by Id */
    getMandatById();
  }, [refreshMandat, user]);

  /* Va en haut de la page à l'ouverture */
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const getUsers = () => {
    // on récupére l'agence du mandat
    let agenceAPi = currentMandat?.agence ? currentMandat.agence.id : "";
    // si le mandat est null, on récupére l'agence de l'utilisateur
    if (
      agenceAPi === "" &&
      !_.isUndefined(user.agencesList) &&
      users.length === 0
    ) {
      agenceAPi = user.agencesList;
      // on supprime la derniére virgule
      if (agenceAPi[agenceAPi.length - 1] === ",") {
        agenceAPi = agenceAPi.slice(0, -1);
      }
      let param = [];
      agenceAPi = agenceAPi.split(",");
      agenceAPi.forEach((element, index) => {
        param.push("agences[]=" + element);
      });
      param.push("represent=true");
      param.push("actif=true");

      requestHelper.get("/api/users?" + param.join("&")).then((response) => {
        setUsers(response.data["hydra:member"]);
      });
    }
  };

  const getMandatById = () => {
    requestHelper
      .doRequest(_ACTIONS.GET, `/api/mandats/${currentIdUrl.id}`)
      .then((response) => {
        if (response.status === 200) {
          setCurrentMandat(response.data);
        }
      });
  };

  /** Fonction pour refresh le mandat  */
  const refresh = () => {
    setRefreshMandat(refreshMandat + 1);
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          border: "2px solid rgb(238, 238, 238)",
          borderRadius: "10px",
          gap: "1rem",
          padding: 4,
          margin: 1,
        }}
      >
        <Grid sx={{ width: "100%" }}>
          <CreationOffreAchat
            register={register}
            errors={errors}
            currentMandat={currentMandat}
            setCurrentMandat={setCurrentMandat}
            refresh={refresh}
            disabledSign={disabledSign}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TransmissionOffreAchat;
